<template>
    <div>
        <div class="confirm-to-change-email-body" v-if="showConfirmToChangeEmail">
        </div>

        <div class="link-was-deactivated" v-if="showDeactivatedLinkMessage">
            <h1 style="color: red">{{$t("changeEmail.linkWasDeactivated")}}</h1>

            <el-row id="back_to_my_page_button_wrapper" >
                <el-button id="back_to_my_page_button" @click="backToMyPage">{{$t("changeEmail.backToMyPageButton")}}</el-button>
            </el-row>
        </div>
    </div>
    
</template>

<script>
    import UserAPI from "../../../api/user/UserApi";
    import Auth from "../../../security/Authentication";
    import AlertService from "../../../service/alert.service";
    import Pages from "../../../router/Pages";

    export default {
        name: "ConfirmToChangeEmail",
        data() {
            return {
                changedEmail: null,
                showConfirmToChangeEmail: true,
                showDeactivatedLinkMessage: false,
            }
        },

        created() {
            let changedEmail = this.$route.query.email;
            let endUserCode = this.$route.query.endUserCode;
            this.changedEmail = changedEmail;

            UserAPI.isEmailUserWantToChangeExactly(changedEmail, endUserCode).then(result => {
                if (result) {
                    this.showConfirmToChangeEmail = true;
                    this.showDeactivatedLinkMessage = false;
                    UserAPI.changeEmail(this.changedEmail, endUserCode).then(result => {
                        this.$auth.setCurrentUser(result.principal.endUserEntity);
                        console.log(result)
                        console.log("End user:")
                        AlertService.success(this.$t("changeEmail.changeEmailSuccessfully"))
                        this.$router.push(Pages.myPage.path)
                    })
                } else {
                    this.showConfirmToChangeEmail = false;
                    this.showDeactivatedLinkMessage = true;
                }
            })
        },

        methods: {
            backToMyPage() {
                this.$router.push(Pages.myPage.path)
            }
        }
    }
</script>

<style scoped lang="scss">

    .confirm-to-change-email-body {
        width: 60%;
        margin-right: 20%;
        margin-left: 20%;
        text-align: center;
    }

    .link-was-deactivated {
        width: 60%;
        margin-left: 20%;
        margin-right: 20%;
        text-align: center;
    }

    #confirm_to_change_email_title{
        font-size: 30px;
        margin-bottom: 10px
    }

    #change_button{
        background-color: #4B86E8;
        color: white;
        width: 200px
    }

    #change_email_message_wrapper {
        text-align: center
    }

    #changed_email {
        color: #4B86E8;
        padding-right: 5px;
    }

    #change_email_message {
        padding-left: 5px
    }

    @media only screen and (max-width: 450px) {
        .confirm-to-change-email-body {
            width: 100%;
            margin-right: 0%;
            margin-left: 0%;
            text-align: center;
        }

        .link-was-deactivated {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%;
            text-align: center;
        }

        #confirm_to_change_email_title{
            font-size: 140%;
            margin-bottom: 10px
        }

        #change_button{
            background-color: #4B86E8;
            color: white;
            width: 100%
        }

        #changed_email {
            color: #4B86E8;
            margin-bottom: 0px;
            margin-top: 0px;
            font-size: 100%;
            padding-right: 5px;
        }

        #change_email_message {
            padding-left: 0px;
            font-size: 100%;
        }

        #is_email_want_change{
            margin-bottom: 0px;
            margin-top: 0px;
            font-size: 100%;
        }

        #change_button{
            margin-top: 20px;
        }

        #change_email_message_wrapper {
            text-align: left;
        }
    }

</style>